import { render, staticRenderFns } from "./DataDisplay.vue?vue&type=template&id=5c90da31&scoped=true&"
import script from "./DataDisplay.vue?vue&type=script&lang=js&"
export * from "./DataDisplay.vue?vue&type=script&lang=js&"
import style0 from "./DataDisplay.vue?vue&type=style&index=0&id=5c90da31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c90da31",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFooter } from 'vuetify/lib/components/VFooter';
installComponents(component, {VDataTable,VFooter})
